import React from 'react';

export default function DocumentListHeader() {
  return (
    <div>
      <h1 className="text-2xl font-bold">Semua Dokumen</h1>
      <p className="text-gray-500">Repository terpusat untuk seluruh dokumen sistem</p>
    </div>
  );
}
